import { BaseComponent } from "../../shared/components/base.component";
import { Component, ViewChild, Input, Output, EventEmitter, OnInit, AfterViewInit } from "@angular/core";
import { MDBDatePickerComponent, ModalDirective } from "ng-uikit-pro-standard";
import { DatePickerInputComponent } from "@npm.chapps.com/chapps.common.angular.library";
import { FormGroup, FormControl } from "@angular/forms";
import { JobService } from "../../shared/service/job.service";
import { LocalStorageService } from '../../shared/service/local-storage.service';
import { AcceptedJobSteps, JobDueDates, JobTimes } from "../../shared/enums/enums";

@Component({
    selector: "app-accept-modal",
    templateUrl: "./accept-modal.component.html",
    styleUrls: ["./accept-modal.component.scss"]
  })
export class AcceptModalComponent extends BaseComponent implements OnInit {
  @ViewChild("modal") 
  modal: ModalDirective;
  
  @Input() id: string;
  @Input() culture: string;
  @Output() success: EventEmitter<null> = new EventEmitter<null>();

  
  public acceptedJobStep: string = AcceptedJobSteps.DEFAULT;
  public submitting: boolean;
  public scheduledOn?: Date = new Date();
  public dateFormGroup: FormGroup;
  
  public get scheduledOnSelector() { return this.dateFormGroup.get('scheduledOnSelector'); }

  public get jobDueDates(): typeof JobDueDates {
    return JobDueDates; 
  }

  public get jobTimes(): typeof JobTimes {
    return JobTimes; 
  }

  public get acceptedJobSteps(): typeof AcceptedJobSteps {
    return AcceptedJobSteps; 
  }
  
  constructor(
    private jobService: JobService,
    private localStorageService: LocalStorageService
  ) {
    super();
  }

  ngOnInit() {
    this.dateFormGroup = new FormGroup({
      'scheduledOnSelector': new FormControl(null, [])
    });
  }

  public show() {    
    this.modal.show();
  }

  public hide() {
    this.acceptedJobStep = AcceptedJobSteps.DEFAULT;
    this.modal.hide();
    this.success.emit(null);
  }

  public accept() {
    this.submitting = true;

    /*if(this.showDatePicker)
      this.scheduledOn = this.dateFormGroup.get('scheduledOnSelector').value;*/
      
    this.jobService
      .acceptJob(
        this.id,
        this.scheduledOn
      )
      .subscribe(() => {
        this.submitting = false;
        this.hide();
      });
  }

  public changeDate(event: JobDueDates){
    const today = new Date();
    switch(event){
      case JobDueDates.TODAY:
        this.scheduledOn = new Date();
        break;
      case JobDueDates.TOMORROW:
        this.scheduledOn = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
        break;
      case JobDueDates.THISWEEK:
        var first = today.getDate() - today.getDay();
        var last = first + 6;
        this.scheduledOn = new Date(today.setDate(last));
        break;
      case JobDueDates.NEXTWEEK:
        var first = today.getDate() - today.getDay();
        var last = first + 6;
        const thisWeek = new Date(today.setDate(last));
        this.scheduledOn = new Date(today.setDate(thisWeek.getDate() + 7));
        break;
      case JobDueDates.SPECIFICDATE:
        this.acceptedJobStep = AcceptedJobSteps.DATE
        this.scheduledOn = new Date();
        break;
      case JobDueDates.NODATE:
        this.scheduledOn = null;
        this.accept();
        break;
    }
  }

  public changeTime(event: JobTimes){
    switch(event){
      case JobTimes.AM:
      break;
      case JobTimes.PM:
        break;
      case JobTimes.MORNING:
        this.scheduledOn.setHours(8, 0, 0, 0);
        break;
      case JobTimes.ENDOFDAY:
        this.scheduledOn.setHours(17, 0, 0, 0);
        break;
      case JobTimes.SPECIFICTIME:
        break;
      case JobTimes.NOTIME:
        this.scheduledOn.setHours(0, 0, 0,0);
        this.accept();
        break;
    }
  }

  public getCountry(): string {
    return this.localStorageService.getCountry();
  }

  public onSelect(event){
    this.scheduledOn = event;
  }

  public next(){
    this.acceptedJobStep = AcceptedJobSteps.TIME
  }
}